import type { AwardType } from './award.types';

export const DEFAULT_PROFILE_BADGES = { isHighlyRecommended: false, isTrustedAgent: false, isPriceExpert: false, repeatAwards: [] };

export interface Badges {
  isHighlyRecommended: boolean;
  isTrustedAgent: boolean;
  isPriceExpert: boolean;
  repeatAwards: RepeatAward[];
}

export interface RepeatAward {
  winningYears: string[];
  awardType: AwardType;
  winType: RepeatAwardWinTypes;
  awardName: string;
  rankedOutOf: number;
}

export type RepeatAwardWinTypes = 'Winner' | 'Ranked';
